export default "__VITE_PUBLIC_ASSET__2904d92a__"